import styled from 'styled-components';

import colors from '../../styles/colors';
import { checkoutPagesFontStyles } from '../../styles/text';

// The coach's checkout theme, as on the page the client paid on.
const Page = styled.main`
  ${checkoutPagesFontStyles};
  display: flex;
  justify-content: center;
  min-height: 100vh;
  padding-top: 24px;
  box-sizing: border-box;
  background-color: ${({ $isDarkTheme }) => ($isDarkTheme ? colors.shades.dark1 : colors.base.alpha)};
  color: ${({ $isDarkTheme }) => ($isDarkTheme ? colors.base.alpha : colors.base.beta)};
`;

const Message = styled.section`
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
  max-width: 420px;
  padding: 40px 16px;
  box-sizing: border-box;
  text-align: center;
`;

const MessageTitle = styled.h1`
  margin: 0;
  font-size: 24px;
  font-weight: 600;
`;

const MessageBody = styled.p`
  margin: 0;
  font-size: 14px;
  line-height: 1.5;
  color: ${colors.shades.gamma14};
`;

export {
  Page,
  Message,
  MessageTitle,
  MessageBody,
};
